import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  SET_CARDBYACCOUNT: function (state, payload) {
    state.cardByaccount = payload
  },
  SELECT_CREDITCARDID: function (state, payload) {
    state.idCreditCard = payload
  }
}
